import {
  Card,
  Row,
  Col,
  Input,
  Button,
  Table,
  Modal,
  Dropdown,
  Steps,
  message,
  Form,
  Typography,
  Image,
  Spin,
  Popconfirm,
  Space,
  Menu,
  Descriptions,
  Select,
} from "antd";
import status1 from "../../assets/img/icon/status1.svg";
import {
  actionGetTicketLog,
  actionGetTickets,
  actionGetTicketDetail,
  actionUpdateTicketStatus,
  actionDeleteTicket,
} from "../../store/actions/ticketAction";
import {
  DeleteOutlined,
  HistoryOutlined,
  UpOutlined,
  PlusSquareOutlined,
  DownOutlined,
  MailOutlined,
  AppstoreOutlined,
  EllipsisOutlined,
  EyeOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import React, { Fragment, useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import ticket from "../../assets/img/comman/ticket.png";
import dayjs from "dayjs";
import { connect } from "react-redux";

const { Search } = Input;
const { Option } = Select;

const Ticket = (props) => {
  const {
    actionGetTickets,
    ticketStatusUpdateData,
    ticketsLoader,
    ticketsData,
    ticketsCount,
    deleteticketsLoading,
    actionDeleteTicket,

    ticketLogLoader,
    actionUpdateTicketStatus,
    ticketStatusUpdateLoader,
    actionGetTicketLog,
    ticketLogData,
    actionGetTicketDetail,
    ticketsDetailLoader,
    ticketsDetailData,
  } = props;

  const { ticketId } = useParams();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [search, setSearch] = useState();
  const [status, setStatus] = useState();

  const showModal = (id) => {
    setIsModalOpen(true);
    actionGetTicketDetail(id);
  };
  const handleOk = (e) => {
    setIsModalOpen(false);
  };
  const handleCancel = (e) => {
    setIsModalOpen(false);
  };

  const onFinishSearch = (value) => {
    setSearch(value.keyword ? value.keyword : "");
    setStatus(value.status ? value.status : "");
    actionGetTickets(
      0,
      10,
      value.keyword ? value.keyword : "",
      value.status ? value.status : ""
    );
  };

  const ticketdata = [
    {
      title: "Service Request No.",
      description: (
        <>{ticketsDetailData && ticketsDetailData.service_request_number}</>
      ),
    },
    {
      title: "Email",
      description: (
        <>
          {ticketsDetailData &&
            ticketsDetailData.email &&
            ticketsDetailData.email.toLowerCase()}
        </>
      ),
    },
    {
      title: "Describe the Issue",
      description: <>{ticketsDetailData && ticketsDetailData.description}</>,
    },

    {
      title: "Primary Troubleshooting",
      description: (
        <>
          <p style={{ textTransform: "lowercase" }}>
            {ticketsDetailData && ticketsDetailData.primary_troubleshooting}
          </p>
        </>
      ),
    },
    {
      title: "Steps Primary Troubleshooting",
      description: (
        <>
          <p style={{ textTransform: "lowercase" }}>
            {ticketsDetailData &&
              ticketsDetailData.primary_troubleshooting_description}
          </p>
        </>
      ),
    },
    {
      title: "Issue according to Priority",
      description: (
        <>
          {" "}
          <p style={{ textTransform: "lowercase" }}>
            {ticketsDetailData && ticketsDetailData.rate_issuue}
          </p>
        </>
      ),
    },
    {
      title: "Status",
      description: (
        <>
          <p style={{ textTransform: "lowercase" }}>
            {ticketsDetailData && ticketsDetailData.status}
          </p>
        </>
      ),
    },
    {
      title: "Screenshot",
      // description: <><p style={{ textTransform: 'lowercase' }}>{ticketsDetailData && ticketsDetailData.roles}</p></>,
      description: (
        <>
          {ticketsDetailData &&
          ticketsDetailData.attachemnets &&
          ticketsDetailData.attachemnets.length > 0 ? (
            <div>
              {ticketsDetailData.attachemnets.map((screenshot, index) => (
                <img
                  className="mr-3"
                  width={50}
                  height={50}
                  key={index}
                  src={screenshot}
                  alt={`Screenshot ${index + 1}`}
                />
              ))}
            </div>
          ) : (
            <p>No screenshots available</p>
          )}
        </>
      ),
    },
  ];

  const [sortedInfo, setSortedInfo] = useState({});
  const [dataList, setDataList] = useState();
  const [modal2Open, setModal2Open] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    actionGetTickets(0, 10);
  }, []);

  const modalOpen = (id) => {
    setModal2Open(true);
    actionGetTicketLog(id);
  };

  const logData = [];
  ticketLogData &&
    ticketLogData.length > 0 &&
    ticketLogData.map((data, index) => {
      logData.push({
        key: index,
        title:
          data.created_at && dayjs(data.created_at).format("YYYY/MM/DD h:mm A"),
        description: data.log,
      });
    });

  const onChange = (id, data) => {
    actionUpdateTicketStatus(id, data);
  };

  const data = [];

  // useMemo(() => {
  ticketsData &&
    ticketsData.length > 0 &&
    ticketsData.map((e, index) =>
      data.push({
        key: index,
        id: e.ticket_id,
        service_request_number: e.service_request_number,
        email: e.email && e.email.toLowerCase(),
        rate_issuue: e.rate_issuue,
        status: (
          <>
            <div id="dropw">
              <Select
                value={e.status}
                name="status"
                onChange={(data) => onChange(e.ticket_id, data)}
                placeholder="Status"
                className="custom-select"
              >
                <Option value="REGISTERED">REGISTERED</Option>
                <Option value="IN_PROCESS">IN_PROCESS</Option>
                <Option value="AWAITING_BUSINESS_CONFIRMATION">
                  AWAITING_BUSINESS_CONFIRMATION
                </Option>
                <Option value="CLOSED">CLOSED</Option>
              </Select>
            </div>
          </>
        ),
        primary_troubleshooting: e.primary_troubleshooting,
        // status: e.status,
        // Image: (
        //   <>
        //     <Image
        //       preview={{ mask: "" }}
        //       width={100}
        //       fallback="data:image/png;base64,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"
        //       src={e.attachemnets[0]}
        //       alt="image"
        //     />
        //   </>
        // ),
      })
    );
  // }, [ticketsData]);
  useMemo(() => setDataList(data), [ticketsData]);

  const onClickPaginationNumber = (e, filter, sorter) => {
    setSortedInfo(sorter);
    actionGetTickets(e.current - 1, e.pageSize);
  };

  const confirm = (id) => {
    actionDeleteTicket(id);
  };

  const columns = [
    {
      title: "Service Request No.",
      dataIndex: "service_request_number",
      key: "service_request_number",
      // sorter: (a, b) =>
      //   a.service_request_number.localeCompare(b.service_request_number),
      // sortOrder:
      //   sortedInfo &&
      //   sortedInfo.columnKey === "service_request_number" &&
      //   sortedInfo &&
      //   sortedInfo.order,
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      // sorter: (a, b) => a.email.localeCompare(b.email),
      // sortOrder:
      //   sortedInfo &&
      //   sortedInfo.columnKey === "email" &&
      //   sortedInfo &&
      //   sortedInfo.order,
    },
    {
      title: "Issue according to Priority",
      dataIndex: "rate_issuue",
      key: "rate_issuue",
      // sorter: (a, b) => a.rate_issuue.localeCompare(b.rate_issuue),
      // sortOrder:
      //   sortedInfo &&
      //   sortedInfo.columnKey === "rate_issuue" &&
      //   sortedInfo &&
      //   sortedInfo.order,
    },
    {
      title: "Primary Troubleshooting",
      dataIndex: "primary_troubleshooting",
      key: "primary_troubleshooting",
      // sorter: (a, b) =>
      //   a.primary_troubleshooting.localeCompare(b.primary_troubleshooting),
      // sortOrder:
      //   sortedInfo &&
      //   sortedInfo.columnKey === "primary_troubleshooting" &&
      //   sortedInfo &&
      //   sortedInfo.order,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      // sorter: (a, b) => a.status.localeCompare(b.status),
      // sortOrder:
      //   sortedInfo &&
      //   sortedInfo.columnKey === "status" &&
      //   sortedInfo &&
      //   sortedInfo.order,
    },
    // {
    //   title: "Image",
    //   dataIndex: "Image",
    //   key: "Image",
    // },

    {
      title: "Action",
      fixed: "right",
      align: "center",
      width: "80px",
      key: "action",
      render: (item) => (
        <Dropdown
          placement="bottom"
          menu={{
            items: [
              {
                label: (
                  <div>
                    <Link
                      // to={`/view-ticket/${item.id}`}
                      onClick={(id) => showModal(item.id)}
                      style={{ color: "black" }}
                    >
                      <EyeOutlined
                        style={{
                          color: "#265BA6",
                          fontSize: "18px",
                          marginRight: 10,
                        }}
                      />
                      View
                    </Link>
                  </div>
                ),
              },
              {
                label: (
                  <div onClick={() => modalOpen(item.id)}>
                    <HistoryOutlined
                      style={{
                        color: "#265BA6",
                        fontSize: "18px",
                        marginRight: 10,
                      }}
                    />
                    Log
                  </div>
                ),
              },
              // {
              //   label: (
              //     <Popconfirm
              //       okButtonProps={{
              //         loading: deleteticketsLoading,
              //       }}
              //       placement="topLeft"
              //       title="Are you sure you want to delete this Ticket?"
              //       onConfirm={() => confirm(item.id)}
              //       okText="Yes"
              //       cancelText="No"
              //     >
              //       <span style={{ color: "black" }}>
              //         <DeleteOutlined
              //           style={{
              //             color: "#265BA6",
              //             fontSize: "18px",
              //             marginRight: 10,
              //           }}
              //         />
              //         Delete
              //       </span>
              //     </Popconfirm>
              //   ),
              // },
              // {
              //   label: (
              //     <Popconfirm
              //       okButtonProps={
              //         {
              //           // loading: deleteUserLoading,
              //         }
              //       }
              //       placement="topLeft"
              //       title="Are you sure to delete this User?"
              //       // onConfirm={() => confirm(item._id)}
              //       okText="Yes"
              //       cancelText="No"
              //     >
              //       <span style={{ color: "black" }}>
              //         <DeleteOutlined
              //           style={{
              //             color: "#265BA6",
              //             fontSize: "18px",
              //             marginRight: 10,
              //           }}
              //         />
              //         Create Knowledge
              //       </span>
              //     </Popconfirm>
              //   ),
              // },
            ],
          }}
        >
          <a>
            <EllipsisOutlined style={{ fontSize: "20px" }} />
          </a>
        </Dropdown>
      ),
    },
  ];

  return (
    <Fragment>
      <Card
        className="main-card no-padding"
        title={
          <>
            <Row align="middle" justify="">
              <Col span={2}>
                <h2 className="text-white text-base">Ticket</h2>
              </Col>
              <Col span={17}>
                {/* <Search
                  name="keyword"
                  className="search-input"
                  placeholder="Search..."
                  allowClear
                  enterButton={
                    <SearchOutlined
                      className="site-form-item-icon"
                      style={{
                        color: "white",
                        width: 25,
                        fontSize: 20,
                      }}
                    />
                  }
                  size="large"
                  onSearch={onSearch}
                /> */}
                <Form
                  className="custom-form"
                  name="basic"
                  layout="inline"
                  onFinish={onFinishSearch}
                  autoComplete="off"
                >
                  <Form.Item name="keyword" className="custom-slect">
                    <Input
                      style={{ width: "100%" }}
                      autoFocus="none"
                      type={"text"}
                      //onChange={(e) => onchangeSearch(e)}
                      prefix={
                        <SearchOutlined className="site-form-item-icon text-white" />
                      }
                      placeholder="Search Here"
                    />
                  </Form.Item>

                  <Form.Item name="status" className="custom-slect">
                    <Select
                      showSearch
                      className="user"
                      placeholder="Select Status"
                      optionFilterProp="children"
                      allowClear
                      onClear={() => setStatus("")}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={[
                        {
                          value: "REGISTERED",
                          label: "Registered",
                        },
                        {
                          value: "IN_PROCESS",
                          label: "In Process",
                        },
                        {
                          value: "AWAITING_BUSINESS_CONFIRMATION",
                          label: "Await Business Confirmation",
                        },
                        {
                          value: "CLOSED",
                          label: "Closed",
                        },
                      ]}
                    />
                  </Form.Item>

                  <Form.Item>
                    <Button
                      className="bg-white search-btn user"
                      type="primary"
                      htmlType="submit"
                    >
                      Search
                    </Button>
                  </Form.Item>
                </Form>
              </Col>
              {/* <Col span={5} align="right">
                {" "}
                <Button type="primary" className="bg-white-btn" size={"large"}>
                  Export
                </Button>
              </Col> */}
            </Row>
          </>
        }
        bordered={false}
        style={{
          width: "100%",
        }}
      >
        <Row>
          <Col span={24}>
            <Table
              className="ticket-table"
              sticky={true}
              size="small"
              pagination={{
                total: ticketsCount,
                hideOnSinglePage: true,
              }}
              columns={columns}
              dataSource={dataList}
              loading={ticketsLoader}
              onChange={(e, filters, sorter) =>
                onClickPaginationNumber(e, filters, sorter)
              }
              scroll={{
                x: 1500,
                y: window.innerWidth < 1500 ? "40vh" : "60vh",
              }}
            />
          </Col>
        </Row>
        <Modal
          className="log-modal"
          title={
            // <Card>
            <Space align="middle">
              <Image preview={false} src={status1} />
              <Typography.Title level={4}>Status</Typography.Title>
            </Space>
            // </Card>
          }
          footer={null}
          centered
          open={modal2Open}
          onOk={() => setModal2Open(false)}
          onCancel={() => setModal2Open(false)}
        >
          <Spin spinning={ticketLogLoader}>
            <Steps
              progressDot
              current={ticketLogData.length}
              direction="vertical"
              items={logData}
            />
          </Spin>
        </Modal>
      </Card>
      <Modal
        title="View Ticket"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        // centered
        className="popUp"
      >
        <div className="user-detail">
          <Row gutter={16}>
            <Col span={24}>
              <Descriptions
                title=""
                layout="horizontal"
                colon={true}
                bordered
                column={1}
              >
                {ticketdata &&
                  ticketdata.length > 0 &&
                  ticketdata.map((item, index) => (
                    <Descriptions.Item
                      key={index}
                      label={item.title}
                      style={{
                        background: index % 2 !== 0 ? "#FFFFFF" : "#E2EEFF",
                      }} // Set color dynamically or default to black
                    >
                      {item.description ? item.description : "-"}
                    </Descriptions.Item>
                  ))}
              </Descriptions>
            </Col>
          </Row>
        </div>
      </Modal>
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    ticketsLoader: state.ticket.ticketsLoader,
    ticketsData: state.ticket.ticketsData,
    ticketLogLoader: state.ticket.ticketLogLoader,
    ticketLogData: state.ticket.ticketLogData,
    ticketsDetailLoader: state.ticket.ticketsDetailLoader,
    ticketsDetailData: state.ticket.ticketsDetailData,
    ticketStatusUpdateLoader: state.ticket.ticketStatusUpdateLoader,
    ticketStatusUpdateData: state.ticket.ticketStatusUpdateData,
    ticketsCount: state.ticket.ticketsCount,
    deleteticketsLoading: state.ticket.deleteticketsLoading,
  };
};

export default connect(mapStateToProps, {
  actionGetTicketLog,
  actionGetTickets,
  actionGetTicketDetail,
  actionUpdateTicketStatus,
  actionDeleteTicket,
})(Ticket);
